import React, { useState, useEffect } from 'react'

import AddCollaboratorLayout from 'presentation/hospital/layouts/AddCollaborator'
import { AddCollaborator as AddCollaboratorUseCase } from 'domain/usecases/collaborator/add-collaborator'
import { Hospital } from 'domain/entities/hospital-model'
import { useStores } from 'presentation/hooks/use-stores'

type AddCollaboratorProps = {
  addCollaborator: AddCollaboratorUseCase
}

export default function AddCollaborator({
  addCollaborator
}: AddCollaboratorProps) {
  const [hospitals, setHospitals] = useState([] as Hospital[])
  const [isLoading, setIsLoading] = useState(true)

  const currentHospital = useStores().currentHospital

  useEffect(() => {
    const loadData = async () => {
      await currentHospital.load()
      setHospitals(currentHospital.hospitalList)
    }
    loadData()
    setIsLoading(false)
  }, [])

  if (isLoading) return <></>

  return (
    <AddCollaboratorLayout
      hospitals={hospitals}
      addCollaborator={addCollaborator}
    />
  )
}
